import {HistoricalTier} from "../Types/HistoricalTier";
export const gaPrice= 375.68;
export const vipPrice=  506.97;
export const deluxePrice= 1070.52;
export const deluxePlusPrice= 1855.07;
export const lastUpdated = "05/28/2026";

const gaTiers: HistoricalTier[] = [
  { name: "Holiday Ticket Presale", cost: 331.48 },
  { name: "Presale increase 1", cost: 353.58 },
  { name: "Post Lineup", cost: 375.68 },
];

const vipTiers: HistoricalTier[] = [
  { name: "Holiday Ticket Presale", cost: 437.89 },
  { name: "Presale increase 1", cost: 473.82 },
  { name: "Post Lineup", cost: 506.97 },
];

const deluxeTiers: HistoricalTier[] = [
  { name: "Holiday Ticket Presale", cost: 1034.59 },
  { name: "Presale increase 1", cost: 1048.43 },
  { name: "Post Lineup", cost: 1070.52 },
];

const deluxePlusTiers: HistoricalTier[] = [
  { name: "Holiday Ticket Presale", cost: 1658.92 },
  { name: "Presale increase 1", cost: 1678.28 },
  { name: "Post Lineup", cost: 1855.07 },
];

function getTierHistoryText(tiers: HistoricalTier[]): string {
  let text = "";
  tiers.forEach((tier) => {
    text += `${tier.name}: ${tier.cost}\n`;
  });
  return text;
}

export function getGaTierHistoryText() { return getTierHistoryText(gaTiers); }
export function getVipTierHistoryText() { return getTierHistoryText(vipTiers); }
export function getDeluxeTierHistoryText() { return getTierHistoryText(deluxeTiers); }
export function getDeluxePlusTierHistoryText() { return getTierHistoryText(deluxePlusTiers); }